export default (theme, colors) => ({
    root: {
        backgroundColor: colors.accentLight[0.25],
    },
    light: {
        backgroundColor: colors.accentLight[0.1],
    },
});
